import React, { useState, useEffect, useContext } from "react";
import { auth, db } from "../firebase/firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import {
  doc,
  setDoc,
  getDocs,
  query,
  where,
  collection,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "./create-account.scss";
import Logo from "../../images/academates-logo.png";
import { IsAuthContext } from "../../../App";

const CreateAccount = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [agreedToCookiePolicy, setAgreedToCookiePolicy] = useState(false);

  const [username, setUserName] = useState("");
  const navigate = useNavigate();

  const contextValues = useContext(IsAuthContext);
  const [isAuthenticated, setIsAuthenticated, , setUserData] = contextValues;

  const handleCreateUser = async (event) => {
    event.preventDefault();

    if (!agreedToCookiePolicy) {
      alert("Please accept the cookie policy to continue");
      return;
    }

    if (
      email === "" ||
      password === "" ||
      username === "" ||
      confirmPassword === ""
    ) {
      alert("Please fill all fields.");
      return;
    }

    if (username.length <= 4) {
      alert("Please choose a longer username");
      return;
    }
    if (password === confirmPassword) {
      const emailQuery = query(
        collection(db, "users"),
        where("email", "==", email)
      );
      const emailQuerySnapshot = await getDocs(emailQuery);

      if (!emailQuerySnapshot.empty) {
        alert("Email already exists. Please use a different email.");
        return;
      }

      const usernameQuery = query(
        collection(db, "users"),
        where("username", "==", username)
      );
      const usernameQuerySnapshot = await getDocs(usernameQuery);

      if (!usernameQuerySnapshot.empty) {
        alert("Username already exists. Please choose a different username.");
        return;
      }

      try {
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );

        setUserData(email);

        const userDocRef = doc(db, "users", email);

        await setDoc(userDocRef, {
          email: email,
          username: username,
          password: password,
        });

        if (userCredential) {
          setIsAuthenticated(true);
        }
      } catch (err) {
        if (email === "" || password === "" || username === "") {
          alert("Please fill all fields.");
        } else if (err.code === "auth/invalid-email") {
          alert("Please enter a valid email.");
        } else {
          alert("There was an error with your request");
        }
      }
    } else {
      alert("The passwords do not match");
    }
  };

  const handleSignIn = () => {
    navigate("/landing-page");
  };
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/home");
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="create-account-container">
      <nav>
        <div className="left-nav-container">
          <img src={Logo} alt="Logo" />
          <span>Academates</span>
        </div>
        <div className="right-nav-container">
          <a href="mailto: infoacademates@gmail.com">Contact</a>
        </div>
      </nav>
      <div className="container">
        <img src={Logo} alt="Logo" />
        <h2>Create Account</h2>

        <form>
          <input
            placeholder="Username..."
            value={username}
            onChange={(e) => setUserName(e.target.value)}
            maxLength={13}
            className="inputs"
          />

          <input
            placeholder="Email..."
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            maxLength={35}
            className="inputs"
          />
          <input
            placeholder="Password..."
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            maxLength={15}
            name="password"
            className="inputs"
          />
          <input
            placeholder="Confirm Password..."
            type="password"
            onChange={(e) => setConfirmPassword(e.target.value)}
            autoComplete="current-password"
            maxLength={15}
            name="password"
            className="inputs"
          />

          <div className="checkbox-container">
            <input
              type="checkbox"
              id="cookiePolicy"
              className="custom-checkbox-input" // Add a class for the custom checkbox input
              checked={agreedToCookiePolicy}
              onChange={(e) => setAgreedToCookiePolicy(e.target.checked)}
            />
            <span className="checkmark"></span>{" "}
            {/* Keep the existing span with the class */}
            <label htmlFor="cookiePolicy">
              I consent this website to use cookies
            </label>
          </div>

          <button onClick={handleCreateUser} type="submit">
            Sign Up
          </button>
        </form>
        <span onClick={handleSignIn}>Go Back</span>
      </div>
    </div>
  );
};

export default CreateAccount;
